import { View, type ViewProps } from 'react-native';

import { cn } from './cn';

export type SurfaceVariant = 'card' | 'well' | 'ink' | 'plain';

const VARIANTS: Record<SurfaceVariant, string> = {
  card: 'bg-card border border-border rounded-2xl',
  well: 'bg-well rounded-2xl',
  ink: 'bg-ink rounded-2xl',
  plain: 'bg-transparent',
};

export interface SurfaceProps extends ViewProps {
  variant?: SurfaceVariant;
  className?: string;
}

/** A warm card/well surface — the base container for rows, cards, and sheets. */
export function Surface({ variant = 'card', className, ...props }: SurfaceProps) {
  return <View className={cn(VARIANTS[variant], className)} {...props} />;
}
